import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import { HashRouter as Router } from "react-router-dom";

import { ThemeProvider } from "@mui/material/styles";
import MyTheme from "./MyTheme";

// Chrome reports this as window "error" when a ResizeObserver callback
// causes another layout in the same frame (react-select, MUI, etc.).
// It is not an app crash; CRA's overlay still treats it as one in dev.
if (process.env.NODE_ENV === "development") {
  window.addEventListener(
    "error",
    (event) => {
      if (
        event.message ===
          "ResizeObserver loop completed with undelivered notifications." ||
        event.message === "ResizeObserver loop limit exceeded"
      ) {
        event.stopImmediatePropagation();
      }
    },
    true
  );
}

ReactDOM.render(
  <ThemeProvider theme={MyTheme}>
    <Router>
      <App />
    </Router>
  </ThemeProvider>,
  document.getElementById("root")
);
